import {
  Box,
  Button,
  FormControl,
  InputAdornment,
  ListItemIcon,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  onGetDonations,
  onGetDonationTypes,
  onGetDonors,
} from "../../src/utils/queries";
import { useRouter } from "next/router";

const DonorsFilter = ({ setFilter, value, setValue, setNames, isOther, noAnonymous }) => {
  // const [value, setValue] = useState([]);
  const [textBox, setTextBox] = useState("");
  const [open, setOpen] = React.useState(false);
  
  const type = ""
  if (isOther[0]) type = "event"
  if (isOther[1]) type = "envelope"
  
  const otherDonors = ""
  if (isOther[0] || isOther[1]) {
    otherDonors = `other_type=${type}`;
  }

  const { isLoading, isSuccess, error, isError, data } = onGetDonors((otherDonors != '') ? otherDonors : "");
  const isEvent = useRouter().pathname.includes("events");
  const [list, setList] = useState([]);
  const [filteredList, setFilteredList] = useState([...list]);
  const filterRef = React.useRef();

  useEffect(() => {
    if (!value.donor_name) {
      setTextBox('')
    }
  }, [value])

  const handleChange = (event) => {
    setTextBox(event.target.value);
    setValue((prev) => ({
      ...prev,
      donor_name: event.target.value?.toLowerCase(),
    }));
    setFilter((prev) => ({
      ...prev,
      donor_name: event.target.value?.toLowerCase(),
      page: 1,
    }));
  };

  const handleList = (event) => {
    event.preventDefault();
    setTextBox(event.target.value);
    setValue((prev) => ({
      ...prev,
      donor_name: event.target.value,
    }));
    setFilter((prev) => ({
      ...prev,
      donor_name: event.target.value,
      page: 1,
    }));
  };


  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const stopPropagation = (e) => {
    switch (e.key) {
      case "ArrowDown":
      case "ArrowUp":
      case "Home":
      case "End":
        break;
      default:
        e.stopPropagation();
    }
  };
  return (
    <FormControl>
      <Select
        autoWidth
        displayEmpty
        size="small"
        value={value.donor_name}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        renderValue={(selected) => {
          if (!selected) {
            return (
              <Typography variant="big">
                {isEvent ? "Name" : "Donor"}
              </Typography>
            );
          }

          return selected;
        }}
        sx={{
          borderRadius: "16px",
          "&.Mui-focused": {
            // color:"primary.main",
            // border:"1px solid black",
            "& .MuiOutlinedInput-notchedOutline": {
              boxShadow: "none",
              //used to remove blue styling
              border: "1px solid",
              borderColor: "grey.main",
            },
          },
        }}
        onChange={(event) => handleChange(event)}
        id="demo-simple-select"
      >
        <MenuItem disabled>TYPE DONOR NAME</MenuItem>
        <TextField
          placeholder="Filter"
          inputRef={filterRef}
          sx={{
            border: "none",
            borderColor: "",
            fontSize: "14px",
            marginBottom: "0.5em",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "grey.border40",
              },
              "&.Mui-focused fieldset": {
                borderColor: "primary.main",
              },
            },
          }}
          value={textBox}
          size="small"
          onKeyDown={stopPropagation}
          onChange={handleList}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <i class="las la-search la-lg"></i>
              </InputAdornment>
            ),
          }}
        />

        {!noAnonymous ?
          <MenuItem key="default" value="Anonymous">
            Anonymous
          </MenuItem> : null}
        {data?.data?.data?.map((donor, i) => (
          <MenuItem key={i} value={`${donor?.first_name} ${donor?.last_name}`}>
            {donor?.first_name} {donor?.last_name}
          </MenuItem>
        ))}

        <Box p={2}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleClose}
          >
            Close
          </Button>
        </Box>
      </Select>
    </FormControl>
  );
};

export default DonorsFilter;
